<span class="snack-bar-template" [class]="data.type" matSnackBarLabel>
    {{ data.text }}
</span>